import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@material-ui/core";

import TareasTerminadas from "../../../general/TareasTerminadas";
import emma_w from "../../../../global/imagenes/emma_w.png";

const fila = (etiqueta, valor) => (
  <Box mb={1.75}>
    <Typography variant="caption" style={{ fontWeight: 800, color: "#0f172a", letterSpacing: 0.2 }}>
      {etiqueta}
    </Typography>
    <Typography variant="body2" style={{ marginTop: 4, color: "#334155" }}>
      {valor && String(valor).trim() ? valor : "—"}
    </Typography>
  </Box>
);

const ModalDetalleEstudiante = ({ open, onClose, detalle, cargando = false }) => {
  const d = detalle || {};

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth scroll="body">
      <DialogTitle style={{ fontWeight: 800, color: "#0f172a", paddingBottom: 8 }}>
        Información de contacto
      </DialogTitle>
      <DialogContent dividers style={{ paddingTop: 12, minHeight: cargando ? 220 : undefined, background: "#ffffff" }}>
        {cargando ? (
          <Box display="flex" alignItems="center" justifyContent="center" py={3} px={1}>
            <TareasTerminadas
              mensaje="Cargando datos de contacto"
              imagen={emma_w}
              widthImg="22%"
              marginTop="0"
              width="100%"
              cargando
            />
          </Box>
        ) : (
          <>
            {fila("Nombre", d.nombreCompleto)}
            {fila("Programa", d.programa)}
            {fila("Correo personal", d.correo_personal)}
            {fila("Teléfono", d.telefono)}
            {fila("Celular", d.celular)}
            {fila("Correo institucional", d.correo)}
          </>
        )}
      </DialogContent>
      <DialogActions style={{ padding: "8px 16px 12px" }}>
        <Button onClick={onClose} color="primary" variant="contained" size="small">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDetalleEstudiante;
